import { queryOptions } from '@tanstack/react-query'
import {
  FamilyApplicationDetails,
  getFamilyApplication,
  getPaginatedProgramFamilyApplications,
  GetPaginatedFamilyApplicationsParams,
  PaginatedFamilyApplications,
  AwardDetail,
  getAwardDetails,
} from '@/queries/family_applications/requests.ts'
import { CustomQueryOptions } from '@/common/types_and_interfaces.ts'

export const FamilyApplicationQueryKeys = {
  list_all: ['family_applications'],
  list_by_program: (programId?: number) => [
    ...FamilyApplicationQueryKeys.list_all,
    programId,
  ],
  paginate_by_program: (params: GetPaginatedFamilyApplicationsParams) => [
    ...FamilyApplicationQueryKeys.list_all,
    'paginated',
    params,
  ],
  details: (scholarship_application_id: number, program_id?: number) => [
    'applicant_detail',
    scholarship_application_id,
    program_id,
  ],
  award_details: (scholarshipApplicationId: number, programId?: number) => [
    'award_details',
    scholarshipApplicationId,
    programId,
  ],
} as const

export class FamilyApplicationQueries {
  static getPaginatedListByProgramId(
    recordsPerPage: number,
    currentPage: number,
    programId?: number,
    search?: string | '',
    selectedFilter?: string,
    sort_by?: string,
    sort_order?: string,
    only_students?: 0 | 1,
    options: CustomQueryOptions<PaginatedFamilyApplications> = {}
  ) {
    const params: GetPaginatedFamilyApplicationsParams = {
      currentPage,
      programId,
      recordsPerPage,
      search,
      selectedFilter,
      sort_by,
      sort_order,
      only_students,
    }

    return queryOptions({
      queryKey: FamilyApplicationQueryKeys.paginate_by_program(params),
      queryFn: () => getPaginatedProgramFamilyApplications(params),
      ...options,
    })
  }

  public static getFamilyApplicationById(
    scholarshipApplicationId?: string,
    selectedProgramYear?: number,
    options: CustomQueryOptions<FamilyApplicationDetails> = {}
  ) {
    return queryOptions({
      queryKey: FamilyApplicationQueryKeys.details(
        parseInt(scholarshipApplicationId!),
        selectedProgramYear
      ),
      queryFn: () =>
        getFamilyApplication(scholarshipApplicationId, selectedProgramYear),
      ...options,
    })
  }

  public static getAwardDetailsByScholarshipApplicationId(
    scholarshipApplicationId: string,
    programId: number,
    options: CustomQueryOptions<AwardDetail[]> = {}
  ) {
    return queryOptions({
      queryKey: FamilyApplicationQueryKeys.award_details(
        parseInt(scholarshipApplicationId!),
        programId
      ),
      queryFn: () => getAwardDetails(scholarshipApplicationId, programId),
      ...options,
    })
  }
}
